import React from 'react'
import { useTranslation } from 'react-i18next'

function ProgramInfo({ programInfo, className = '' }) {
    const { t } = useTranslation()
    if (!programInfo?.programName || !programInfo?.dayNumber) return null
    return (
        <p className={`text-sm text-darkenPurple font-medium ${className}`} title={`${programInfo.programName} – ${t('day')} ${programInfo.dayNumber}`}>
            <span className="text-[#413F5E99]">{programInfo.programName}</span>
            {' – '}
            {t('day')} {programInfo.dayNumber}
        </p>
    )
}

export default ProgramInfo
